/** JWT values only identify client cache ownership; the API enforces authorization. */
export function getRunAuditActorId(token: string): string {
  try {
    const encoded = token.split(".")[1];
    if (!encoded) return "";
    const normalized = encoded.replace(/-/g, "+").replace(/_/g, "/");
    const claims: unknown = JSON.parse(globalThis.atob(normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=")));
    if (!claims || typeof claims !== "object") return "";
    const identity = claims as { sub?: unknown; id?: unknown; sid?: unknown; lg?: unknown };
    const actor = typeof identity.sub === "string" ? identity.sub : identity.id;
    const session = typeof identity.sid === "string" ? identity.sid : identity.lg;
    return typeof actor === "string" && actor ? `${actor}:${typeof session === "string" ? session : ""}` : "";
  } catch { return ""; }
}

export function canReadRunAudit(permissions: unknown, isActive: unknown): boolean {
  return isActive === 1 && Array.isArray(permissions) && permissions.some((entry: unknown) => {
    if (!entry || typeof entry !== "object") return false;
    const permission = entry as { roles_code?: unknown; read?: unknown };
    return permission.roles_code === "03-06" && permission.read === 1;
  });
}
